/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum PersonTransferRequestStatus {
    NEW = 'new',
    PENDING = 'pending',
    REJECTED = 'rejected',
    ACCEPTED = 'accepted',
    TRANSFERRED = 'transferred',
    REVERTED = 'reverted',
    MANUALLY_RETURNED = 'manuallyReturned',
}
